"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var DistrictsApi = /** @class */ (function () {
    function DistrictsApi(axiosInstance) {
        var _this = this;
        this.add = function (data) { return _this.instance.post('/api/districts/', data); };
        this.deleteDistrictCourses = function (districtId) {
            return _this.instance.post("/api/districts/" + districtId + "/reset-courses");
        };
        this.getAll = function () { return _this.instance.get('/api/districts/'); };
        this.getOne = function (id) { return _this.instance.get("/api/districts/" + id); };
        this.getOneForAdmin = function (id) { return _this.instance.get("/api/districts/" + id + "/admin"); };
        this.importStudents = function (districtId, schoolCode) {
            return _this.instance.get("/api/aeries/importStudents/" + districtId + "/" + schoolCode);
        };
        this.importDistrictCourses = function (districtId) {
            return _this.instance.get("/api/aeries/importDistrictCourses/" + districtId);
        };
        this.importSchools = function (districtId) { return _this.instance.get("/api/aeries/importSchools/" + districtId); };
        this.importStaff = function (districtId) { return _this.instance.get("/api/aeries/importStaff/" + districtId); };
        this.update = function (id, name, enableStaffDashboard) {
            return _this.instance.post("/api/districts/" + id, {
                name: name,
                enableStaffDashboard: enableStaffDashboard,
            });
        };
        this.resetQuestions = function (id) { return _this.instance.post("/api/districts/" + id + "/reset-questions"); };
        this.updateQuestions = function (id, questions) {
            return _this.instance.post("/api/districts/" + id + "/questions", {
                questions: questions,
            });
        };
        this.instance = axiosInstance || axios_1.default;
    }
    return DistrictsApi;
}());
exports.default = DistrictsApi;
